module.exports = __webpack_public_path__ + "static/media/grin-stars@2x.afb2aa9a.jpg";